import React from "react";
import { usePrefill } from "../context/PrefillContext";

// Shown on form pages while Lextria Dashboard data is being used to pre-fill fields
const PrefillBanner = () => {
  const { prefill, clearPrefill } = usePrefill();
  if (!prefill) return null;

  return (
    <div className="bg-amber-50 border-2 border-amber-300 text-amber-900 rounded-lg px-4 py-3 mb-6 flex items-center justify-between gap-3">
      <span className="text-sm font-medium">
        Pre-filled from Lextria Dashboard: <strong>{prefill.tracking_id || prefill.patent_title || "patent"}</strong>
        <span className="text-amber-700"> - check every field before generating.</span>
      </span>
      <button
        type="button"
        onClick={clearPrefill}
        className="text-sm font-semibold underline hover:text-amber-700 whitespace-nowrap"
        title="Stop pre-filling forms you open next (fields already filled stay as they are)"
      >
        Clear
      </button>
    </div>
  );
};

export default PrefillBanner;
